/** Gap between the diff card and the editor when side-by-side */
export const kDiffCardGap = 16
/** Minimum left padding before the card switches to overlay mode */
export const kDiffCardMinLeft = 8
